import { TreePine } from "lucide-react";

const ITEMS = [
  "Land Clearing",
  "Forestry Mulching",
  "Excavation & Grading",
  "Retaining Walls",
  "Hydroseeding",
  "Aggregate Delivery",
  "Driveways",
  "Trail Cutting",
  "Property Maintenance",
  "Almaguin Highlands",
  "Muskoka",
];

export const Marquee = () => {
  return (
    <div
      className="bg-[#0C1827] border-y border-[#1E324A] py-5 overflow-hidden"
      data-testid="editorial-marquee"
      aria-label="Services offered across Almaguin and Muskoka"
    >
      <div className="marquee-track">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center shrink-0" aria-hidden={copy === 1}>
            {ITEMS.map((item) => (
              <span key={`${copy}-${item}`} className="flex items-center">
                <span className="font-display font-bold uppercase tracking-[0.25em] text-slate-500 text-sm px-8 whitespace-nowrap">
                  {item}
                </span>
                <TreePine size={14} className="text-[#F5A623] shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
